import PropTypes from 'prop-types';
import { CLICKSTREAM_EVENT_TYPE } from './clickStreamEventSchema';
export default {
  newLanePayload: PropTypes.shape({
    envelope: PropTypes.shape({
      event_template_id: PropTypes.string,
      event_template_version_id: PropTypes.string,
      event_type_id: PropTypes.string,
      event_type_version_id: PropTypes.string,
      event_client_start_dtm: PropTypes.string
    }),
    clickstream_trigger: PropTypes.shape({
      trigger_location_nm: PropTypes.oneOf(['home_details', 'search_results', 'home', 'owner_dashboard', 'how_much_is_my_home_worth']),
      trigger_type_nm: PropTypes.oneOf(Object.values(CLICKSTREAM_EVENT_TYPE)),
      trigger_object_nm: PropTypes.oneOf(['property_details_component|neighborhood', 'property_details_component|summary', 'property_details_component|home_value', 'property_details_component|summary', 'property_details_component|overview', 'property_details_component|right_rail', 'search_results', 'home|rtb1', 'home|rtb2', 'home|rtb3', 'home|top', 'home|sticky', 'no_trigger_object']),
      trigger_source_nm: PropTypes.oneOf(['onsite_message_component|top', 'onsite_message_component|sticky', 'onsite_message_component|bottom', 'onsite_message_component|rtb1', 'onsite_message_component|rtb2', 'onsite_message_component|rtb3', 'onsite_message_component|right_rail', 'onsite_message_component|hero_image', 'button_to_interact_with_bottom_onsite_message', 'button_to_interact_with_top_onsite_message', 'button_to_interact_with_right_rail_onsite_message', 'button_to_interact_with_rtb1_onsite_message', 'button_to_interact_with_rtb2_onsite_message', 'button_to_interact_with_rtb3_onsite_message', 'button_to_interact_with_sticky_onsite_message']),
      input_selector_nm: PropTypes.oneOf(['mouse', 'keyboard', 'touch', 'other'])
    }),
    semanticBlock: PropTypes.shape({
      semantic_event_nm: PropTypes.oneOf(['omp_placement_view', 'omp_placement_interaction']),
      topic_tag_txt: PropTypes.arrayOf('omp')
    }),
    omp: PropTypes.shape({
      event_type_nm: PropTypes.oneOf(Object.values(CLICKSTREAM_EVENT_TYPE)),
      skip_display_reason_txt: PropTypes.string,
      should_display_ind: PropTypes.bool,
      global_handout_ind: PropTypes.bool,
      placement_holdout_ind: PropTypes.bool,
      placement_nm: PropTypes.string,
      test_phase_nm: PropTypes.oneOf(['baseline', 'targetSelection', 'portfolioIntegration', 'unknown']),
      bucket_nm: PropTypes.oneOf(['CONTROL', 'BASELINE_CTRL', 'BASELINE_TREATMENT', 'TARGET_SELECTION_CTRL', 'TARGET_SELECTION_TREATMENT', 'PORTFOLIO_INTEGRATION_CTRL', 'PORTFOLIO_INTEGRATION_TREATMENT']),
      placement_id: PropTypes.number,
      throttle_pass_ind: PropTypes.bool,
      last_modified_dtm: PropTypes.string,
      event_id: PropTypes.string,
      decision_context_guid: PropTypes.string,
      decision_context_encoded_zuid: PropTypes.string,
      selected_treatment_id: PropTypes.number,
      selected_treatment_nm: PropTypes.string,
      selected_treatment_status_cd: PropTypes.string,
      selected_treatment_last_modified_dtm: PropTypes.string,
      selected_treatment_lob_nm: PropTypes.string,
      selected_treatment_experiment_family_nm: PropTypes.string,
      selected_treatment_experiment_iteration_txt: PropTypes.string,
      selected_treatment_variation_nm: PropTypes.string,
      qualified_treatment_portfolio_nm: PropTypes.arrayOf(PropTypes.string),
      qualified_treatment_portfolio_test_nm: PropTypes.arrayOf(PropTypes.string),
      qualified_treatment_target_selection_nm: PropTypes.arrayOf(PropTypes.string),
      qualified_treatment_baseline_evaluation_nm: PropTypes.arrayOf(PropTypes.string)
    }),
    // Validate below props in MTT-2963
    property_info: PropTypes.object,
    search_filter: PropTypes.object,
    search_map: PropTypes.object,
    search_result: PropTypes.object
  })
};